@if (isProduktvalApplicable) {
  <div class="mall-container">
    @if (isEgenskogOrVirkeskopWithAllowHSGroups) {
      <rask-selector
        [label]="texts.mallar"
        [viewFormatter]="valueFormatter"
        [(ngModel)]="produktonsmallId"
        (change)="onProduktionsmallChanged($event)"
        [formatter]="selectionFormatter"
        [values]="produktionsmallar"
        [disabled]="!canEdit()"
        [showHeader]="true">
        <ng-container header>
          <div class="custom-highlight">
            <a [routerLink]="['/minaproduktionsmallar']" target="_blank">Mina produktionsmallar <i class="far fa-external-link" aria-hidden="true"></i></a>
          </div>
        </ng-container>
      </rask-selector>
    }
    <rask-checkbox
      [text]="texts.cbx"
      [(ngModel)]="visaEndastMedProduktionsmal">
    </rask-checkbox>
  </div>
}
<rask-produktval
  aid="ao-produktval"
  [canEdit]="canEdit()"
  [handelssortimentsgrupper]="handelssortimentsgrupper"
  [handelssortimentsgruppProduktvalsrader]="handelssortimentsgruppProduktvalsrader"
  [visaEndastMedProduktionsmal]="visaEndastMedProduktionsmal"
  [isProduktvalApplicable]="isProduktvalApplicable"
  [isSimuleringApplicable]="isSimuleringApplicable"
  [onBeforeSelectionEvent]="onBeforeSelectionEvent"
  (onSelectionEvent)="onSelectionEvent($event)">
</rask-produktval>
@if (isProduktvalApplicable) {
  <rask-arbetsorder-produktval-summary
    [arbetsorder]="arbetsorderWrapper.arbetsorder"
    [handelssortimentsgruppProduktvalsrader]="handelssortimentsgruppProduktvalsrader">
  </rask-arbetsorder-produktval-summary>
}
<div class="footer-area d-flex justify-content-between">
  @if (isEgenskog && isProduktvalApplicable) {
    <rask-button class="col text-center"
      color="secondary"
    (click)="simulera()" [disabled]="!isFormValid || !canEdit() || !canSimulateAtgardstyp()">{{texts.simulera}}</rask-button>
  }
  @if (!canSimulateAtgardstyp()) {
    <rask-icon class="info-atgardstyp" icon="fas fa-info-circle" text="För denna åtgärdstyp ska volymer anges manuellt"></rask-icon>
  }

  @if (isVirkeskop) {
    <rask-button class="col text-center"
      ngbTooltip="Hämta handelssortiment och volymer från kontraktets förkalkyl"
      color="secondary" (click)="hamtaVirkeskostnader()" [disabled]="!isFormValid || !canEdit()">{{texts.hamta}}
    </rask-button>
  }
  @if (isEgenskogOrVirkeskopWithAllowHSGroups && isProduktvalApplicable && canEdit()) {
    <rask-arbetsorder-produktval-produktionsmall
      [selectedProduktval]="valdaproduktrader"
      [arbetsorder]="arbetsorderWrapper.arbetsorder"
      (onProduktionsMallAddedEvent)="onProduktionsMallAddedEvent()">
    </rask-arbetsorder-produktval-produktionsmall>
  }
  @if (isProduktvalApplicable || isVirkeskop) {
    <rask-button class="col text-center"
      aid="produktval-rensa"
      color="secondary"
      (click)="unselectAll(texts.confirmHeaderRensa, texts.confirmTextRensa)" [disabled]="!canEdit()" negative>
    {{commonTexts.clear}}</rask-button>
  }
</div>
<div class="footer-area">
  @if (isEgenskog && isProduktvalApplicable) {
    <p class="col-12 float-start">{{texts.senastSimuleradText}}
    {{senastSimulerad}}</p>
  }
  @if (!isEgenskog) {
    <p class="col-12 float-start">{{texts.senastVolymhamtadText}} {{senastVolymhamtad}}</p>
  }
</div>
@if (isProduktvalApplicable) {
  <rask-checkbox
    aid="checkbox-produktsatt"
    [disabled]="!isProduktsattValid || !canEdit()"
    [attr.disabled]="!isProduktsattValid ? '' : null"
    (change)="produktsattUtfortChanged($event)"
    [text]="texts.produktsattUtfort"
    [ngModel]="arbetsorderWrapper.arbetsorder.produktsatt">
  </rask-checkbox>
}
@if (isProduktvalApplicable) {
  <rask-info [text]="texts.produktsattInfoBox"></rask-info>
}

@if (isVardekapApplicable) {
  <rask-checkbox
    class="ms-5"
    [disabled]="!canEdit()"
    (change)="vardekapChanged($event)"
    text="Inkludera PINar för värdekap"
    [ngModel]="arbetsorderWrapper.arbetsorder.vardekap">
  </rask-checkbox>
}
@if (isVardekapApplicable) {
  <rask-info text="Produktinstruktioner för värdekap (LUMP) skickas till skördare"></rask-info>
}

@if (produktsattReminder) {
  <div class="row validation-message">
    <rask-validation-message-row message="{{produktsattReminder.message}}" type="warning">
    </rask-validation-message-row>
  </div>
}

